import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';

import { TiempoComponent } from "./tiempo.component";
import { TiempoFormComponent } from "./tiempo-form.component";
import { SharedModule } from "../../../shared/shared.module";
import { GrupoRegistrosTiempoComponent } from "./components/grupo-registros-tiempo/grupo-registros-tiempo.component";
import { MapaGeolocalizacionModule } from "./components/mapa-geolocalizacion/mapa-geolocalizacion.module";
import { MotivoDialogComponent } from "./components/motivo-dialog/motivo-dialog.component";
import { EditarRegistroModalComponent } from "./components/editar-registro-modal/editar-registro-modal.component";
import { HistorialRegistroModalComponent } from "./components/historial-registro-modal/historial-registro-modal.component";

@NgModule({
    declarations: [
        TiempoComponent,
        TiempoFormComponent,
        GrupoRegistrosTiempoComponent,
        MotivoDialogComponent,
        EditarRegistroModalComponent,
        HistorialRegistroModalComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        MatButtonModule,
        MatCardModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        MatTooltipModule,
        MatToolbarModule,
        MatExpansionModule,
        MatListModule,
        MatChipsModule,
        MapaGeolocalizacionModule,
    ],
    exports: [TiempoComponent]
})
export class TiempoModule {}
